import moment from 'moment';
import { bool } from 'prop-types';
import React from 'react';

import commentShape from '../../../../../shapes/comment';
import theme from '../../../../../theme';
import { formatUsername } from '../../../../../utils/common';
import InfoSection from '../../card-shared-components/card-info-section/card-info-section';
import {
  AuthorLabel,
  CommentContent,
  CreatedAtLabel,
  CommentInfo,
} from './activity-comment.style';

/**
 * Component to display and activity comment.
 * @param {object} params - Object containing props
 * @param {object} param.comment - Comment object to display
 * @param {boolean} params.alternateBackground - If true - background is alternate light gray.
 * @returns {element} - Activity comment component
 */
const ActivityComment = ({ comment, alternateBackground }) => (
  <InfoSection
    testId="activity-comment-container"
    backgroundColor={alternateBackground ? theme.palette.custom.lightGray : ''}
    removePadding
  >
    <CommentContent>
      <p>{comment.text}</p>
      <CommentInfo>
        <AuthorLabel>{formatUsername(comment.author.name)}</AuthorLabel>
        <CreatedAtLabel>{moment(comment.createdAt).format('M/D HH:mm')}</CreatedAtLabel>
      </CommentInfo>
    </CommentContent>
  </InfoSection>
);

ActivityComment.propTypes = {
  comment: commentShape.isRequired,
  alternateBackground: bool,
};

ActivityComment.defaultProps = {
  alternateBackground: false,
};

export default ActivityComment;
